module.exports = __webpack_public_path__ + "static/media/GameBg.bdc250d0.png";